import { conformToMask } from 'react-text-mask';
import { masks } from './normalizeUtils';

const isNumber = value => {
  return !Number.isNaN(parseFloat(value)) && Number.isFinite(value);
};

const parseSeconds = secondsValue => {
  if (!isNumber(secondsValue)) {
    return 'значение секунд не соответствует формату';
  }
  const seconds = parseFloat(secondsValue);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const formatTime = (value, type) => {
    const strValue = String(value);
    let parsedValue;
    if (value === 0) {
      return '';
    } else if (value > 10 && value < 20) {
      parsedValue = strValue;
    } else {
      parsedValue = strValue[strValue.length - 1];
    }
    switch (parsedValue) {
      case '0':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
      case '10':
      case '11':
      case '12':
      case '13':
      case '14':
      case '15':
      case '16':
      case '17':
      case '18':
      case '19':
        return `${value} ${type}`;
      case '1':
        return `${value} ${type}у`;
      case '2':
      case '3':
      case '4':
        return `${value} ${type}ы`;
      default:
        return '';
    }
  };
  return `${formatTime(mins, 'минут')} ${formatTime(secs, 'секунд')}`;
};

const getMaskedValue = (value, type) => {
  const mask = masks[type];

  const conformedField = conformToMask(value, mask);

  return conformedField ? conformedField.conformedValue || '' : '';
};

export default { parseSeconds, getMaskedValue };



// WEBPACK FOOTER //
// ./src/utils/formatUtils.js